import { Page } from "@/models/page-models/Page";

export const ProductionReportSummary: Page = {
  "path": "production-report-summary",
  "name": "Production Report Summary",
  "props": {
    "data": {
      "title": "Production Report Summary",
      "printable": "FALSE",
      "url": "production-report-summary",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "datepicker",
                  "variable": "formData.q.createdAt.start",
                  "label": "Production Start Date",
                  "disabled": "FALSE"
                },
                {
                  "type": "datepicker",
                  "variable": "formData.q.createdAt.end",
                  "label": "Production End Date",
                  "disabled": "FALSE"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.q.order",
                  "label": "Search Order By ID",
                  "disabled": "FALSE",
                  "items": "fetchedData.orderResults.data.orders",
                  "itemText": "_id",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,orderDescription,{{__item}})",
                  "dropdownType": "search",
                  "multiple": true,
                  "searchFunctions": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "searchOrdersForProductionReports",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v2/order/production/search?pattern={{__selectedObject}}",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.orderResults"
                      },
                      "name": "searchOrdersForProductionReports"
                    }
                  ]
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.q.process",
                  "label": "Process",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.allProcesses.data}}",
                  "items": "fetchedData.allProcesses.data.0.data",
                  "itemText": "name",
                  "itemValue": "name",
                  "multiple": true
                },
                {
                  "type": "dropdown",
                  "variable": "formData.q.productLine",
                  "label": "Product Line",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.productLines.data}}",
                  "items": "fetchedData.productLines.data.0.data",
                  "itemText": "name",
                  "itemValue": "name",
                  "multiple": true
                },
                {
                  "type": "dropdown",
                  "variable": "formData.q.machines",
                  "label": "Machine",
                  "disabled": "FALSE",
                  "items": "fetchedData.machines.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "multiple": true
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Search Production Reports",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyDefaultPageAndLimit",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getDefaultPageAndLimit",
                        "arg2Key": "destinationKey",
                        "arg2Value": "formData",
                        "arg3Key": "append",
                        "arg3Value": "TRUE",
                        "arg4Key": "destinationKeyType",
                        "arg4Value": "Object"
                      },
                      "name": "copyDefaultPageAndLimit"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "searchProductionReports",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/production/reports/search",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.productionReports",
                        "arg3Key": "postData",
                        "arg3Value": "formData"
                      },
                      "name": "searchProductionReports"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "secondary"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Production Reports",
                  "disabled": "FALSE",
                  "items": "fetchedData.productionReports.data.docs",
                  "headers": [
                    {
                      "value": "_id",
                      "text": "ID"
                    },
                    {
                      "value": "machine.name",
                      "text": "Machine"
                    },
                    {
                      "value": "createdBy.displayName",
                      "text": "Operator"
                    },
                    {
                      "value": "timeSpent",
                      "text": "Time Spent"
                    },
                    {
                      "value": "createdAt",
                      "text": "Production Date",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                    },
                    {
                      "value": "factoryTicket.order.customer",
                      "text": "Customer",
                      "formula": "fn(HELPER_FN,customerAlias,{{__item.factoryTicket.order.customer}})"
                    },
                    {
                      "value": "factoryTicket.order._id",
                      "text": "Order #",
                      "type": "url",
                      "url": "/order/{{__item.factoryTicket.order._id}}"
                    },
                    {
                      "value": "factoryTicket.order.product",
                      "text": "Product Description",
                      "formula": "fn(HELPER_FN,productAlias,{{__item.factoryTicket.order.product}})"
                    },
                    {
                      "value": "factoryTicket.order.productLine",
                      "text": "Product Line"
                    },
                    {
                      "value": "factoryTicket.order.unit.unit2",
                      "text": "Unit"
                    },
                    {
                      "value": "process.type",
                      "text": "Process"
                    },
                    {
                      "value": "inputsSum",
                      "text": "Input Qty",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.inputsSum}})"
                    },
                    {
                      "value": "outputsSum",
                      "text": "Output Qty",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.outputsSum}})"
                    },
                    {
                      "value": "setupWaste",
                      "text": "Setup Waste",
                      "formula": "fn(HELPER_FN,numFormat,{{__item.setupWaste}})"
                    },
                    {
                      "value": "totalWaste",
                      "text": "Total Waste",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,numFormat,fn(SUM,{{__item.setupWaste}},{{__item.maintenanceWaste}},{{__item.trimWaste}},{{__item.productionWaste}}))"
                    }
                  ],
                  "tableType": "static",
                  "footer": {
                    "inputsSum": "fn(HELPER_FN,numFormat,{{fetchedData.productionReports.data.summary.inputProcessSum}})",
                    "outputsSum": "fn(HELPER_FN,numFormat,{{fetchedData.productionReports.data.summary.outputProcessSum}})",
                    "setupWaste": "fn(HELPER_FN,numFormat,{{fetchedData.productionReports.data.summary.totalSetupWaste}})",
                    "totalWaste": "fn(HELPER_FN,numFormat,{{fetchedData.productionReports.data.summary.totalWaste}})",
                    "factoryTicket.order.unit.unit2": "Total"
                  },
                  "pagination": {
                    "pageVariable": "formData.page",
                    "serverItemsLengthVariable": "fetchedData.productionReports.data.totalDocs",
                    "pageChangeFns": [
                      {
                        "executionOrder": 2,
                        "pageFunction": {
                          "name": "searchProductionReports",
                          "type": "fnGetData",
                          "arg1Key": "apiUrl",
                          "arg1Value": "/api/v1/production/reports/search",
                          "arg2Key": "storeInVar",
                          "arg2Value": "fetchedData.productionReports",
                          "arg3Key": "postData",
                          "arg3Value": "formData"
                        },
                        "name": "searchProductionReports"
                      }
                    ],
                    "itemsPerPageVariable": "formData.limit"
                  }
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getAllMachines",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/machines/get",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.machines"
        },
        "name": "getAllMachines"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getProductLines",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=product-lines1",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.productLines"
        },
        "name": "getProductLines"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "resetFilters",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultFilters",
          "arg2Key": "destinationKey",
          "arg2Value": "formData",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "resetFilters"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getAllProcesses",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=processes",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.allProcesses"
        },
        "name": "getAllProcesses"
      }
    ],
    "functions": [
      {
        "name": "getDefaultPageAndLimit",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": "1",
          "limit": "25"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultFilters",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "q": "{}"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "PRODUCTION_MANAGER",
  "visible": true,
  "menuGroup": "Reports"
}